import { Config } from "../../configurations/config";
export const CalendarHolidays_API = {
  //------------------------ CalendarHolidays_API Listing Screen API -----------------------//

  GetCalendarHolidaysbyPagination: `${Config.server_url}${Config.api_prefix}/CalendarHoliday`,
};
